import { Injectable } from '@angular/core'
import { Observable, catchError, combineLatestWith, of, switchMap, take } from 'rxjs'
import { AuthService } from './auth.service'
import { environment } from '@appEnvironments/environment'

@Injectable({ providedIn: 'root' })
export class AppConfigProvider {

   constructor(

      private _authService: AuthService
      //TODO private _accountsService: AccountsService
   ) { }

   init(): Observable<boolean> {

      this._prepareRouteUris()

      //return this._authService.initializeSiteConfig().pipe(
      //   of({})//TODO combineLatestWith(this._accountsService.refreshCurrentUser())
      //)
      return this._authService.initializeSiteConfig().pipe(
         take(1),
         switchMap((siteConfig/*TODO [siteConfig, user]*/) => {

            return of(true)
         }),
         catchError(error =>

            of(false)
         )
      )
   }

   private _prepareRouteUris(): void {

      /* iterative method to loop over route objects
         to create usuable uris for ease of routing
         and no need to concatenate routes in code
      */

      let setConditionalUri = (parentUri?: any, uri?: any): string => {
         return parentUri
            ? uri
               ? `${parentUri}/${uri}`
               : parentUri
            : uri
               ? uri
               : ''
      }

      let setUrl = (obj: any, parentBaseUri?: any): void => {
         let baseUri = obj.baseUri

         Object.entries(obj)
            .forEach(([key, value]) => {
               if (typeof value === "object") {

                  // build "baseUri" to pass to children objects
                  baseUri = setConditionalUri(parentBaseUri, obj.baseUri)

                  setUrl(value, baseUri)

               } else if (key === 'uri') {

                  // set uri based on parent routes
                  obj[key] = setConditionalUri(parentBaseUri, value)
               }
            })
      }

      let routes = environment.routes

      setUrl(routes)
   }

}
